import { Box, Checkbox, CircularProgress, Container, FormControlLabel, Grid, Modal, Paper, styled, Table, TableBody, TableCell, tableCellClasses, TableContainer, TableHead, TableRow } from '@mui/material';
import React, { Component } from 'react'
import Constantes from '../php/Constantes';

const StyledTableCell = styled (TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: theme.palette.common.black,
      color: theme.palette.common.white,
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: 14,
    },
}));
  
const StyledTableRow = styled(TableRow)(({ theme }) => ({
    '&:nth-of-type(odd)': {
        backgroundColor: theme.palette.action.hover,
    },
    // hide last border
    '&:last-child td, &:last-child th': {
        border: 0,
    },
}));

const Item = styled(Paper)(({ theme }) => ({
    backgroundColor: theme.palette.mode === 'dark' ? '#1A2027' : '#F4F6F6',
    ...theme.typography.body2,
    padding: theme.spacing(1),
    textAlign: 'center',
    color: theme.palette.text.secondary,
}));

const styleModal = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 500,
    bgcolor: 'background.paper',
    border: '2px solid #000',
    boxShadow: 24,
    p: 4,
};

class ConsultaMarcasPlanilla extends Component {
    constructor(props){
        super(props);
        this.state = {
            consultaMarca: {
                numeroFuncionario: '',
                mes: '',
                anio: '',
            },
            consulta: false,
            loading: false,
            marcasManual: [],
            modalBorrar: false,
        }
        this.manejarCambiosDatos = this.manejarCambiosDatos.bind(this);
        this.manejoEnvioNumeroFuncionario = this.manejoEnvioNumeroFuncionario.bind(this);
        this.manejarAtras = this.manejarAtras.bind(this);
        this.manejarEnvioBorrar = this.manejarEnvioBorrar.bind(this);
        this.manejarEnvioBaja = this.manejarEnvioBaja.bind(this);
        this.cerrarModal = this.cerrarModal.bind(this);
    }
    render(){
        return (
            <>
                {this.state.consulta
                ?
                    <Container>
                        <TableContainer>
                            <Table sx={{minWidth: 700}}>
                                <TableHead>
                                    <TableRow>
                                        <StyledTableCell align="center" colSpan={10}>Marcas Manual - Funcionario: {this.state.marcasManual[0].numeroFuncionario} - {this.state.marcasManual[0].nombreFuncionario}</StyledTableCell>
                                    </TableRow>
                                    <TableRow>
                                        <StyledTableCell>Fecha</StyledTableCell>
                                        <StyledTableCell>Marca 1</StyledTableCell>
                                        <StyledTableCell>Marca 2</StyledTableCell>
                                        <StyledTableCell>Marca 3</StyledTableCell>
                                        <StyledTableCell>Marca 4</StyledTableCell>
                                        <StyledTableCell>Marca 5</StyledTableCell>
                                        <StyledTableCell>Marca 6</StyledTableCell>
                                    </TableRow>
                                </TableHead>
                                <TableBody>
                                    {this.state.marcasManual.map((datosOmi) => (
                                        <StyledTableRow key={datosOmi.idMarcasManual}>
                                            <StyledTableCell>{datosOmi.fechaMarca}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.marca1}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.marca2}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.marca3}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.marca4}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.marca5}</StyledTableCell>
                                            <StyledTableCell>{datosOmi.marca6}</StyledTableCell>
                                        </StyledTableRow>
                                    ))}
                                </TableBody>
                            </Table>
                        </TableContainer>
                        {this.state.consulta ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarAtras}>Volver</button> : null }
                        {this.state.consulta ? <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBorrar}>Borrar Marcas</button> : null }
                    </Container>
                :
                    <Container>
                        <h3>Marcas Manual</h3>
                        {this.state.loading
                        ?
                            <div style={{placeItems: 'center'}}>
                                <Box sx={{alignItems: 'center'}}>
                                    <CircularProgress/>
                                </Box>
                            </div>
                        :
                            null
                        }
                        <form className='formulario'  onSubmit={this.manejoEnvioNumeroFuncionario}>
                            {this.state.errores ? (<div className='alert alert-danger'> {this.state.errores}</div>) : null}
                            {this.state.notificaciones ? (<div className="alert alert-success" > {this.state.notificaciones}</div>) : null}
                            <Box sx={{ flexGrow: 1}}>
                                <Grid container spacing={2} rowSpacing={1}>
                                    <Grid item xs={2}>
                                        <Item>Número de Funcionario <p style={{color: 'red', display: 'inline', fontSize: '15px'}} >*</p></Item>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='numeroFuncionario' value={this.state.consultaMarca.numeroFuncionario} onChange={this.manejarCambiosDatos} type="text" />
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Mes</Item>
                                    </Grid>
                                    <Grid item xs={1.5}>
                                        <select style={{width:"100%", border:"2px solid #D6EAF8"}} id='mes'  value={this.state.consultaMarca.mes} onChange={this.manejarCambiosDatos}>
                                            <option value=''>MES</option>
                                            <option value={'01'}>ENERO</option>
                                            <option value={'02'}>FEBRERO</option>
                                            <option value={'03'}>MARZO</option>
                                            <option value={'04'}>ABRIL</option>
                                            <option value={'05'}>MAYO</option>
                                            <option value={'06'}>JUNIO</option>
                                            <option value={'07'}>JULIO</option>
                                            <option value={'08'}>AGOSTO</option>
                                            <option value={'09'}>SETIEMBRE</option>
                                            <option value={'10'}>OCTUBRE</option>
                                            <option value={'11'}>NOVIEMBRE</option>
                                            <option value={'12'}>DICIEMBRE</option>
                                        </select>
                                    </Grid>
                                    <Grid item xs={2}>
                                        <Item>Año</Item>
                                    </Grid>
                                    <Grid item xs={1.5}>
                                    <input style={{border: "2px solid #D6EAF8", width: "100%"}} id='anio' value={this.state.consultaMarca.anio} onChange={this.manejarCambiosDatos} type="text" />
                                    </Grid>
                                    <Grid item xs={1}>
                                        <button className="btn btn-outline-primary mx-2" type='submit'>Buscar</button>
                                    </Grid>
                                </Grid>
                            </Box>
                        </form>
                    </Container>
                }
                <Modal open={this.state.modalBorrar}>
                    <form className='formulario1'>
                        <Box sx={styleModal}>
                            <h3 style={{textAlign:'center'}}>¿Confirmar Baja Marca Manual?</h3>
                            <Grid container spacing={2} rowSpacing={1}>
                                <Grid item xs={2}>

                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-primary mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.manejarEnvioBaja}>Confirmar</button>
                                </Grid>
                                <Grid item xs={4}>
                                    <button className="btn btn-outline-danger mx-2" style={{marginTop:'2rem'}} type='button' onClick={this.cerrarModal}>Cancelar</button>
                                </Grid>
                            </Grid>
                        </Box>
                    </form>
                </Modal>
            </>
        )
    }

    manejarCambiosDatos(e){
        e.preventDefault();
        this.setState({
            errores: null,
            notificaciones: null,
            consulta: false,
            modalBorrar: false,
        });
        const clave = e.target.id;
        let valor = e.target.value;
        this.setState(state => {
            const funcionarioActualizado = state.consultaMarca;
            funcionarioActualizado[clave] = valor;
            return{
                consultaMarca: funcionarioActualizado,
            };
        })
    }

    async manejoEnvioNumeroFuncionario(e){
        e.preventDefault();
        if((this.state.consultaMarca.numeroFuncionario === '')){
            this.setState({
                errores: 'DEBE INGRESAR EL NÚMERO DE FUNCIONARIO!',
            })
        }else if((this.state.consultaMarca.mes === '')){
            this.setState({
                errores: 'DEBE INDICAR EL MES',
            })
        }else if((this.state.consultaMarca.anio === '')){
            this.setState({
                errores: 'DEBE INGRESAR EL AÑO',
            })
        }else{
            this.setState({
                loading: true,
            })
            const cargaUtil = JSON.stringify([this.state.consultaMarca]);

            const respuesta = await fetch(`${Constantes.RUTA_API}/consultar_marcaManualPlanilla.php`,{
                method: 'POST',
                body: cargaUtil,
            })
            const exito = await respuesta.json();

            this.setState({
                loading: false,
                errores: exito[0],
            })

            if(exito[0] === 'ok'){
                this.setState({
                    loading: false,
                    marcasManual: exito[1],
                    errores: null,
                    notificaciones: null,
                    consulta: true,
                })
            }
        }
    }
    
    manejarAtras(e){
        e.preventDefault();
        this.setState({
            consultaMarca: {
                numeroFuncionario: '',
                mes: '',
                anio: '',
            },
            consulta: false,
            loading: false,
            marcasManual: [],
            modalBorrar: false,
        })
    }

    async manejarEnvioBorrar(e){
        e.preventDefault();
        this.setState({
            modalBorrar: true,
            notificaciones: null,
            errores: null,
        });
    }
    
    async manejarEnvioBaja(e){
        e.preventDefault();

        const cargaUtil = JSON.stringify([this.state.consultaMarca]);

        const respuesta = await fetch(`${Constantes.RUTA_API}/borrar_marcaManualPlanilla.php`,{
            method: 'POST',
            body: cargaUtil,
        })
        const exito = await respuesta.json();

        this.setState({
            loading: false,
            notificaciones: null,
            errores: exito[0],
        })

        if(exito[0] === 'ok'){
            this.setState({
                loading: false,
                errores: null,
                notificaciones: 'LAS MARCAS FUERON ELIMINADAS DE FORMA CORRECTA!',
                consulta: false,
                modalBorrar: false,
                consultaMarca: {
                    numeroFuncionario: '',
                    mes: '',
                    anio: '',
                },
            })
        }
    }

    cerrarModal(e){
        e.preventDefault();
        this.setState({
            modalBorrar: false,
        })
    }
}

export default ConsultaMarcasPlanilla